var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.846 9.215v5.156h3.75v-3.75a.94.94 0 01.937-.937h.938a.94.94 0 01.937.937v3.75h3.75V9.215M.971 8.277L7.339 1.91a.937.937 0 011.326 0l6.368 6.368"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHBhdGggc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTIuODQ2IDkuMjE1djUuMTU2aDMuNzV2LTMuNzVhLjk0Ljk0IDAgMCAxIC45MzctLjkzN2guOTM4YS45NC45NCAwIDAgMSAuOTM3LjkzN3YzLjc1aDMuNzVWOS4yMTVNLjk3MSA4LjI3NyA3LjMzOSAxLjkxYS45MzcuOTM3IDAgMCAxIDEuMzI2IDBsNi4zNjggNi4zNjgiLz48L3N2Zz4=";
export { SvgIconHome as ReactComponent };